import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { history } from 'nallian-shared-ui/lib/config/history';
import { Button, Modal, Mo } from 'nallian-shared-ui/lib/components';
import RemoveOrganisationContactService from '../../services/contacts/removeOrganisationContactService';

const RemoveContact = ({
  organisationId,
  contactId,
  open,
  returnRoute,
  removeOrganisationContactFetch,
  dispatchRemoveOrganisationContactDelete,
}) => {
  const { t } = useTranslation();

  const handleGoBack = useCallback(() => history.push(returnRoute), [returnRoute]);

  const handleRemove = useCallback(() => {
    dispatchRemoveOrganisationContactDelete(organisationId, contactId, handleGoBack, t);
  }, [dispatchRemoveOrganisationContactDelete, handleGoBack, organisationId, contactId, t]);

  if (!open) return null;

  return (
    <Modal open basic size="tiny">
      <Mo.Header>{t('areYouSureYouWantToRemoveContact')}</Mo.Header>
      <Mo.Actions>
        <Button
          inverted
          content={t('cancel')}
          onClick={handleGoBack}
          disabled={removeOrganisationContactFetch.pending}
        />
        <Button
          primary
          inverted
          content={t('confirm')}
          onClick={handleRemove}
          loading={removeOrganisationContactFetch.pending}
          disabled={removeOrganisationContactFetch.pending}
        />
      </Mo.Actions>
    </Modal>
  );
};

RemoveContact.propTypes = {
  dispatchRemoveOrganisationContactDelete: PropTypes.func.isRequired,
  removeOrganisationContactFetch: PropTypes.object.isRequired,
  organisationId: PropTypes.string.isRequired,
  contactId: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

export default RemoveOrganisationContactService(RemoveContact);
